import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from "react-router-dom";
import {useIntl} from "react-intl";

import {Box, TableCell, TableRow} from "@mui/material";

import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";

import TopProductCell from "../../../../TopTablesComponents/TopProductCell";

import {black500, greyishBlue500} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {navigateOnClick} from "utils/navigateOnClick";

RetailerStockAlertRow.propTypes = {
    rank: PropTypes.number.isRequired,
    retailer: PropTypes.shape({
        name: PropTypes.string,
        totalAlerts: PropTypes.number,
        lostRevenue: PropTypes.number,
        topProducts: PropTypes.arrayOf(PropTypes.shape({
            image: PropTypes.string,
            sku: PropTypes.string,
            alerts: PropTypes.number,
        })),
    }).isRequired,
    currency: PropTypes.string,
};

function RetailerStockAlertRow({rank, retailer, currency}) {
    const {id, name, logo, totalAlerts = 0, lostRevenue = 0, topProducts = []} = retailer;

    const history = useHistory();
    const intl = useIntl();

    return (
        <TableRow
            onClick={(e) => navigateOnClick(e, MarketplaceRoutes.RETAILER_SHOW(id), history)}
           hover
           sx={{
                "td" : {padding: '20px 10px'},
                "td:last-of-type": { paddingRight: '20px' },
                "td:first-of-type": { paddingLeft: '20px' },
               cursor: 'pointer'
            }}
        >
            <TableCell
                sx={{
                    pl: "24px",
                    color: greyishBlue500,
                    fontSize: "14px",
                    fontWeight: 600,
                    width: "32px"
                }}
            >
                {rank}
            </TableCell>

            <TableCell>
                <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                    <span style={{fontSize: "14px", fontWeight: 600, color: black500}}>
                        {name}
                    </span>
                </Box>
            </TableCell>

            <TableCell align="left" sx={{fontSize: "14px", fontWeight: 600, color: black500}}>
                {totalAlerts.toLocaleString()}
            </TableCell>

            <TableCell align="left">
                <FormattedNumberWithCurrency value={lostRevenue} currency={currency}/>
            </TableCell>

            <TableCell>
                <Box sx={{display: "flex", gap: "6px"}}>
                    {topProducts.map((p, i) => (
                        <TopProductCell
                            retailerId={id}
                            id={p.productId}
                            key={i}
                            image={p.image}
                            sku={p.sku}
                            bottomContent={(
                                <b>{Number(p.alerts).toLocaleString()} {intl.formatMessage({ id: "dashboard.stockAlerts.table.header.alerts" })}</b>
                            )}
                        />
                    ))}
                </Box>
            </TableCell>
        </TableRow>
    );
}

export default RetailerStockAlertRow;
